import abstractModel from "../../core/ShopModel";

let resource = 'retailers/regional_configs';

const model = abstractModel(resource);

model.getOne = async (params) => {
  const newResource = `${resource}/${params.id}`;

  return model.get({}, { path: newResource });
}

export default model;
